import { DownloadOutlined, GlobalOutlined } from "@ant-design/icons";
import { Masonry } from "@mui/lab";
import { Button, Card, Tabs, theme } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomWidgets from "./CustomWidgets";
import {
    DashboardGrids,
    dashboardUrlList,
    qualityMatricsGrids,
    qualityMetricsUrlList,
    ExternalVendorDashboardGrids,
} from "./constant";
import "./Home.css";
import DailyManagmentChart from "../DailyManagmentDashboard/Index";
import { RevenueBreakdown } from "../Charts/RevenueBreakdown";
import TransactionAnalytics from "../Charts/TransactionAnalytics";

const { TabPane } = Tabs;

const toNumberArray = (values) => {
    if (!Array.isArray(values)) return [];

    return values
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value));
};
const transactionChartFilterOptions = [
    { key: "all", title: "Check Ins and Walk Ins" },
    { key: "1", title: "Check Ins" },
    { key: "2", title: "Walk Ins" },
];
function Home() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const navigate = useNavigate();
    const userRole = getUserRole();
    const {
        selectedDates,
        selectedHotels,
        selectedHotelType,
        selectedHotelGroup,
        selectedServiceModel,
        selectedHotelActiveType,
        selectedCallCenters,
        selectedShifts,
        homeActiveTab,
        updateHomeActiveTab,
    } = useContext(SettingContext);

    const [APIs, setAPIs] = useState(filterAPI());
    const [start_date, end_date] = selectedDates;
    const hotel_ids = selectedHotels;
    const [transactionTimes, setTransactionTimes] = useState([]);
    const [transactionAnalyticsCounts, setTransactionAnalyticsCounts] =
        useState(0);
    const [transactionChartFilter, setTransactionChartFilter] = useState("all");
    const handleWidgetData = useCallback((widgetData, configs) => {
        if (configs?.url !== "getDashboardReviewsCounts") return;
        setTransactionAnalyticsCounts(
            transactionChartFilter === "all"
                ? Number(widgetData?.operation_type_1_count) +
                      Number(widgetData?.operation_type_2_count)
                : transactionChartFilter === "1"
                ? widgetData?.operation_type_1_count
                : widgetData?.operation_type_2_count,
        );
        setTransactionTimes(toNumberArray(widgetData?.times));
    }, []);

    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        hotel_type: selectedHotelType,
        hotel_active_type: selectedHotelActiveType,
        call_centers: selectedCallCenters,
        shift_types: selectedShifts,
        group_ids: selectedHotelGroup.includes("all") ? [] : selectedHotelGroup,
        service_model: selectedServiceModel,
    });

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    function filterAPI(hotelType = selectedHotelType) {
        let finalList = [];
        if (userRole === "External Vendor" || userRole === "Customer") {
            finalList = dashboardUrlList.filter(
                (e) =>
                    e.url === "getDashboardKioskCounts" ||
                    e.url === "getDashboardReviewsCounts" ||
                    e.url === "getDashboardCommonCounts",
            );
            return finalList;
        }
        switch (hotelType) {
            case "kiosk":
                finalList = dashboardUrlList.filter(
                    (e) =>
                        e.url === "getDashboardKioskCounts" ||
                        e.url === "getDashboardReviewsCounts" ||
                        e.url === "getDashboardCommonCounts" ||
                        e.url === "getDashboardCallCounts" ||
                        e.url === "getDashboardNewCallCounts" ||
                        e.url === "getDashboardCashCounts" ||
                        e.url === "getDashboardShiftNotesCounts" ||
                        e.url === "getDashboardMissedcallsRateCounts",
                );
                break;
            case "operation":
                finalList = dashboardUrlList.filter(
                    (e) =>
                        e.url === "getDashboardHotelCounts" ||
                        e.url === "getDashboardCommonCounts" ||
                        e.url === "getDashboardDynaCounts",
                );
                break;
            default:
                finalList = dashboardUrlList;
                break;
        }
        return finalList;
    }
    useEffect(() => {
        const API = filterAPI();
        console.log(API);
        setAPIs(API);
    }, [selectedHotelType, selectedHotelActiveType]);

    useEffect(() => {
        setFormData({
            ...formData,
            hotel_type: selectedHotelType,
            hotel_active_type: selectedHotelActiveType,
            hotel_ids: [],
            all_selected: true,
        });
    }, [selectedHotelType, selectedHotelActiveType]);

    useEffect(() => {
        setFormData((previous) => ({
            ...previous,
            call_centers: selectedCallCenters,
            shift_types: selectedShifts,
        }));
    }, [selectedCallCenters, selectedShifts]);

    useEffect(() => {
        setFormData((previous) => ({
            ...previous,
            group_ids: selectedHotelGroup.includes("all")
                ? []
                : selectedHotelGroup,
        }));
    }, [selectedHotelGroup]);

    useEffect(() => {
        setFormData((previous) => ({
            ...previous,
            service_model: selectedServiceModel,
        }));
    }, [selectedServiceModel]);

    function showMap() {
        navigate(`/map`);
    }

    async function downloadReport() {
        console.log("Download Reports");
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        let res;
        if (homeActiveTab == 1) {
            res = await HTTP("/dashboard/getAllDashboardDataReport", {
                ...tempFormData,
            });
        } else {
            res = await HTTP("/dashboard/getAllQualityTechMatrixCountReport", {
                ...tempFormData,
            });
        }

        downloadCSV(
            res,
            homeActiveTab == 1
                ? `dashboard_reports`
                : "quality_metrics_reports",
        );
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    <div className="flex ml-auto gap-2 items-center">
                        {userRole === "External Vendor" ||
                        userRole === "Customer" ? (
                            <Button
                                variant="outlined"
                                className="margin-right-5"
                                onClick={downloadReport}
                            >
                                Download
                            </Button>
                        ) : (
                            <div className="flex gap-1">
                                {homeActiveTab != "3" && (
                                    <Button
                                        type="primary"
                                        icon={<DownloadOutlined />}
                                        className="margin-right-5"
                                        onClick={downloadReport}
                                    >
                                        Download
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                }
            />
            <Tabs
                type="card"
                destroyInhomeActiveTabPane
                onChange={(tab) => {
                    updateHomeActiveTab(`${tab}`);
                }}
                activeKey={homeActiveTab}
                defaultActiveKey={homeActiveTab}
            >
                <TabPane key="1" tab="Dashboard">
                    <Masonry columns={1} spacing={1}>
                        <div className="dashboard-count-card">
                            {APIs.map((e) => (
                                <CustomWidgets
                                    key={e.queryKey}
                                    grids={
                                        userRole === "External Vendor"
                                            ? ExternalVendorDashboardGrids
                                            : DashboardGrids
                                    }
                                    configs={e}
                                    onData={handleWidgetData}
                                    transactionChartFilter={
                                        transactionChartFilter
                                    }
                                />
                            ))}

                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full mt-[10px]">
                                <Card className="lg:col-span-2 bg-card border border-border rounded-lg p-3 shadow-lg">
                                    <TransactionAnalytics
                                        transactionAnalyticsCounts={
                                            transactionAnalyticsCounts
                                        }
                                        transactionTimes={transactionTimes}
                                        transactionChartFilterOptions={
                                            transactionChartFilterOptions
                                        }
                                        transactionChartFilter={
                                            transactionChartFilter
                                        }
                                        setTransactionChartFilter={
                                            setTransactionChartFilter
                                        }
                                    />
                                </Card>

                                <Card className="lg:col-span-1 bg-card border border-border rounded-lg p-3 shadow-lg">
                                    <RevenueBreakdown />
                                </Card>
                            </div>
                        </div>
                    </Masonry>
                </TabPane>
                {userRole !== "External Vendor" && userRole !== "Customer" ? (
                    <>
                        <TabPane key="2" tab="Quality Tech Metrics">
                            <div className="dashboard-count-card">
                                {qualityMetricsUrlList.map((e) => {
                                    return (
                                        <>
                                            <CustomWidgets
                                                key={e.queryKey}
                                                grids={qualityMatricsGrids.filter(
                                                    (e) => !e.parent,
                                                )}
                                                configs={e}
                                                transactionChartFilter={
                                                    transactionChartFilter
                                                }
                                            />
                                        </>
                                    );
                                })}
                            </div>
                            <hr style={{ borderColor: "#80808057" }} />
                            <h4 style={{ marginLeft: "12px", color: "grey" }}>
                                PMS Softwares
                            </h4>
                            <div className="dashboard-count-card">
                                <CustomWidgets
                                    grids={qualityMatricsGrids.filter(
                                        (e) => e?.parent == "PMS Softwares",
                                    )}
                                    configs={{
                                        queryKey: "qualityMetrixNew",
                                        url: "getMoreSupportTicketErrorCounts",
                                    }}
                                />
                            </div>
                            <hr style={{ borderColor: "#80808057" }} />
                            <h4 style={{ marginLeft: "12px", color: "grey" }}>
                                Key Softwares
                            </h4>
                            <div className="dashboard-count-card">
                                <CustomWidgets
                                    grids={qualityMatricsGrids.filter(
                                        (e) => e?.parent == "Key Softwares",
                                    )}
                                    configs={{
                                        queryKey: "qualityMetrixNew",
                                        url: "getMoreSupportTicketErrorCounts",
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="3" tab="Aavgo Daily Management">
                            <DailyManagmentChart />
                        </TabPane>
                    </>
                ) : null}
            </Tabs>
        </Card>
    );
}

export { DashboardGrids, Home };
